import {SearchResponseType} from "@SearchResults/types/SearchResponse.type";
import useFindSelectedRouteFromSearchParams
    from "@SearchResults/features/additionalInfo/hooks/useFindSelectedRouteFromSearchParams";
import {useOutletContext} from "react-router";
import RouteType from "@Route/types/Route.type";

export default function useSingleSelectedRouteResolvedFromParams(isReturn: boolean): RouteType {
    const searchQuery: SearchResponseType = useOutletContext()
    return <RouteType>useFindSelectedRouteFromSearchParams(searchQuery, isReturn)
}